import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  updateUserRequest,
  updateUserRequestSuccess,
  updateUserRequestError,
} from "../../../slices/teams/members/UpdateUserSlice";

export const UpdateUser = (id, userData) => async (dispatch) => {
  try {
    dispatch(updateUserRequest());

    const url = `${endpoints.updateUser}/${id}`;


    const response = await axiosInstance.post(url, userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    dispatch(updateUserRequestSuccess(response.data));
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Failed to update user";

    const _error = {
      data: errorMessage,
      status: error?.response?.status,
    };

    dispatch(updateUserRequestError(_error));
    throw _error;
  }
};
